const getPreventivo = function (state) {
  return {...state.preventivo}
}

export default {
  getPreventivo
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/getters/preventivo.js